// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorFull_content__e30Gb","message":"ErrorFull_message__LWert","backButton":"ErrorFull_backButton__mhurn"};